
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.orderForm, arguments)" @resolve="submitHandle">
		<c-form ref="orderForm" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="订单编号">
					<c-input name="order_code" placeholder="请输入，不填将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="客户名称">
					<c-select name="customer_id" async v-model="customer_id" @search="searchCustomer" :value-data="customerOptions" @change="changeCustomer"></c-select>
					<template #handle>
						<c-link icon v-if="auth('b_customer_edit')" @click="globalDialog('customerEdit',{})">创建客户</c-link>
					</template>
				</c-form-item>
				<c-form-item label="要求交货时间" required>
					<c-datetime name="plan_delivery_date" type="date" format="yyyy-MM-dd"></c-datetime>
				</c-form-item>
				<!-- <c-form-item :label="false" v-if="editState">
					<c-qrcode :value="h5_web" size="76"></c-qrcode>
				</c-form-item> -->
				<!--自定义字段数据-->
				<custom-form ref="customForm" work-type="1"></custom-form>
			</c-form>

			<c-title>产品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" view-id="10001" work-type="41">
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_types:[1]}}}, productSelectorHandle)">添加产品</c-button>
					</template>
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--产品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					
					<!--销售数量-->
					<template #aux_product_count="{data}">
						<c-input name="aux_product_count" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.aux_product_count" :clear="false" @change="changeCount(data)" :append-text="data.aux_unit"></c-input>
					</template>
					
					<!--换算率-->
					<template #aux_unit_count="{data}">
						<c-input name="aux_unit_count" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.aux_unit_count" :clear="false" @change="changeCount(data)"></c-input>
					</template>
					
					<!--换算率说明-->
					<template #aux_unit_count_tip="{data}">
						<c-tooltip tip="提示" width="360" align="end">
							<template #tip>
								<p>单位转换倍率说明：</p>
								<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
								<p>销售数量（辅单位）* 换算率 = 产品数量（主单位）</p>
								<p>如：1（kg） * 1000 = 1000（g）</p>
								<p>换算率修改后系统会自动计算产品数量</p>
							</template>
						</c-tooltip>
					</template>
					
					<!--产品数量-->
					<template #main_product_count="{data}">
						<c-input name="main_product_count" type="number" decimal="6" :range="[0.000001,99999999]" v-model="data.main_product_count" :clear="false" :append-text="data.unit"></c-input>
					</template>
					
					<!--单价-->
					<template #product_price="{data}">
						<c-input type="number" decimal="6" :range="[0,99999999]" v-model="data.product_price" :clear="false" @change="changeCount(data)"></c-input>
					</template>
					
					<!--小计-->
					<template #product_money="{data}">
						<c-input type="number" decimal="6" :range="[0,99999999]" v-model="data.product_money" :clear="false" @change="changeMoney(data)"></c-input>
					</template>
					
					<c-table-column
                        type="button"
                        label="操作"
						width="105"
                    >
                        <template #default="{data,remove}">
							<c-table-button icon="tf-copy" @click="copyProductRow(data)">复制</c-table-button>
							<c-table-button v-if="auth('b_order_create') || auth('b_order_edit')" icon="tf-trash" @click="removeProductRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				order_id:0,
				editState: false,
				h5_web:'',
				customer_id:0,
				customerOptions: [],
				deleteProductList: [],
				is_copy:false           //是否是复制页面
			}
		},

		methods: {
			open(data, is_copy) {
				this.is_copy = is_copy||false;
				this.editState = !this.is_copy && !!data;
				
				//初始化自定义字段控件
				this.$refs.customForm.init();
				//初始化产品列表控件
				this.$refs.productTable.init();
				
				this.deleteProductList = [];
				//清空表单数据
				this.$refs.orderForm.clear();
				
				if (data) {
					this.order_id = data.id;
					this.getDetail();
				}else {
					this.order_id = 0;
				}
				this.$refs.dialog.open({
					title: data ? (this.is_copy ? '复制销售订单' : '编辑销售订单') : '创建销售订单'
				});
			},
			
			/*******搜索订单详情*******************/
			getDetail() {
				this.request({
					url:'/order/detail',
					data: {
						id: this.order_id
					},
					loading: true,
					success: data => {
						if (this.is_copy){
							this.order_id = 0;
							data.detailInfo.order_code = '';
						}
						
						this.h5_web = data.detailInfo.h5_web;
						//订单基本信息
						this.$refs.orderForm.set(data.detailInfo);
						//存在客户
						if(data.detailInfo.customer_id){
							//处理选中客户信息
							this.customerOptions = [{
								name: data.detailInfo.customer_code +' | ' +data.detailInfo.customer_name,
								value: data.detailInfo.customer_id
							}];
						}
						
						//加载工单列表
						this.$refs.productTable.$refs.list.setData(data.productList);
					}
				});
			},

			changeCustomer({data}) {
				if (!data) return;
				this.$refs.customForm.setDefaultData({
					work_type_id: 1,
					source_list: [[{
						ref_work_type_id: 11,
						ref_id: data.id
					}]]
				});
			},
			
			/****行内数据变更事件**/
			changeCount(data){
				data.product_money = parseFloat(((data.aux_product_count||0) * (data.product_price||0)).toFixed(6));
				data.main_product_count = parseFloat(((data.aux_product_count||0) * (data.aux_unit_count||1)).toFixed(6));
			},
			
			/****行内数据变更事件**/
			changeMoney(data){
				if(data.aux_product_count){
					data.product_price = parseFloat(parseFloat(parseFloat(((data.product_money||0) / (data.aux_product_count||1)).toFixed(6))).toFixed(2));
				}
			},

			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/******选择产品响应方法*********/
			productSelectorHandle(data) {
				
				//处理数据
				var productIds = data.map(item => {
					return item.id;
				});
				
				//按选中的产品重新加载产品详细信息
				this.request({
					url:'/product/listSubUnit',
					data: {
						business_type: 1,
						customer_id: this.customer_id,
						product_ids: productIds
					},
					success: async data => {
						//处理数据
						this.$refs.productTable.$refs.list.push(
							await this.$refs.productTable.setDefaultData(data.map(item => {
								return Object.assign({}, item, {
									product_id: item.id,
									id: null,
									aux_product_count: null,
									product_price: item.last_price,
									product_money: 0,
									create_date: null,
									create_user_realname: null,
									main_product_count: null
								});
							}), {
								work_type_id: 41,
								source_list: data.map(item => {
									return [{
										ref_work_type_id: 7,
										ref_id: item.product_id
									}]
								})
							})
						);
					}
				});
			},
			
			/*****复制转单数据******/
			copyProductRow(data){
				this.$refs.productTable.$refs.list.push(data);
			},
			
			/******删除产品行数据********/
			removeProductRow(data, remove) {
				if (data.id && data.id > 0){
					this.deleteProductList.push(data.id);
				}
				remove();
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//产品列表
				var product_list = this.$refs.productTable.$refs.list.getData();
				
				this.$refs.orderForm.submit({
					url: this.order_id==0?'/order/add':'/order/edit',
					rule: {
						plan_delivery_date:'请选择要求交货时间',
						product_list: data => { 
							var flag = true;
							if(product_list.length == 0){
								let msg = "请至少有一个产品信息";
								return msg;
							} 
							product_list.forEach(item => {
								if(!item.aux_product_count || !item.aux_unit_count || !item.main_product_count){
									flag = false;
								}
							});

							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}
							//自定义字段校验
							return this.$refs.productTable.validate();
						},
						...this.$refs.customForm.rule
					},
					dataFormatter: data => {
						data.id = this.order_id||0;
						data.customer_id = data.customer_id||0;
						//产品列表
						data.product_list = product_list.map(item => {
							return {
								id: item.id,
								product_id: item.product_id,
								aux_product_count: item.aux_product_count,
								aux_unit_id: item.aux_unit_id,
								aux_unit_count: item.aux_unit_count,
								main_product_count: item.main_product_count,
								product_price: item.product_price||0,
								product_money: item.product_money||0,
								custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
							}
						});
						//被删除的任务ID列表
						data.delete_product_list = this.deleteProductList.map(item => {
							return {id:item}
						});
						//表单自定义字段
						data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:this.editState ? '编辑销售订单成功' : '创建销售订单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>